<script context="module">
    import { IRIS } from "@saehrimnir/dataset";

    const petal_colors = {
        "Iris-setosa": "#5d5faa",
        "Iris-versicolor": "#67479c",
        "Iris-virginica": "#aa80b9",
        default: "purple"
    };
    const sepal_colors = {
        "Iris-setosa": "#b8bcdf",
        "Iris-versicolor": "#baaed5",
        "Iris-virginica": "#a893bd",
        default: "mediumpurple"
    };
    const scales = IRIS.columns.map(col => scaleLinear([0, IRIS.statistics[col].max], [0, 5]));
    const values = IRIS.values;
    const labels = IRIS.labels;
</script>

<script>
    import { scaleLinear } from "d3";
    export let index;
    export let stroke = "none";
    export let size = 2;
    $: [a, b, c, d] = index >= 0 ? values[index] : [5, 3, 8, 3];
    $: sepallength = scales[0](a) * size;
    $: selapwidth = scales[1](b) * size;
    $: petallength = scales[2](c) * size;
    $: petalwidth = scales[3](d) * size;
    $: label = index >= 0 ? labels[index] : "default";
</script>

<g>
    {#each [0, 120, 240] as angle}
        <g transform="rotate({angle})">
            <path d="M {size} 0 
                    v {4 * size} 
                    Q {petalwidth / 2} {4 * size} {petalwidth / 2} {4 * size + petallength / 2}
                    Q {petalwidth / 2} {4 * size + petallength} {0} {4 * size + petallength}
                    Q {-petalwidth / 2} {4 * size + petallength} {-petalwidth / 2} {4 * size + petallength / 2}
                    Q {-petalwidth / 2} {4 * size} {-size} {4 * size}
                    v {-4 * size} Z"
                stroke={stroke}
                stroke-width={size / 10}
                fill={petal_colors[label]}>

            </path>
        </g>
    {/each}
    {#each [60, 180, 300] as angle}
        <g transform="rotate({angle})">
            <path d="M {size} 0 
                     v {2 * size} 
                     Q {selapwidth / 2} {2 * size} {selapwidth / 2} {2 * size + sepallength / 2}
                     C {selapwidth / 2} {2 * size + sepallength / 2 + sepallength / 5} {selapwidth / 5} {2 * size + sepallength} {0} {2 * size + sepallength}
                     C {-selapwidth / 5} {2 * size + sepallength} {-selapwidth / 2} {2 * size + sepallength / 2 + sepallength / 5} {-selapwidth / 2} {2 * size + sepallength / 2}
                     Q {-selapwidth / 2} {2 * size} {-size} {2 * size}
                     v {-2 * size} Z"
                stroke={stroke}
                stroke-width={size / 10}
                fill={sepal_colors[label]}>
            </path>
        </g>
    {/each}
    <g>
        <circle r={size} fill="yellow" />
    </g>
</g>

<style>
    path {
        filter: drop-shadow(2px 4px 4px #111a);
    }
</style>